import { useEffect } from "react";

const SITE = "https://dosacloud.net";

function setMeta(attr, key, content) {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

function setCanonical(href) {
  let el = document.head.querySelector('link[rel="canonical"]');
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", "canonical");
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
}

// Sets unique, per-route SEO metadata for this SPA (title, description, canonical, OG tags).
export const Seo = ({ title, description, path }) => {
  useEffect(() => {
    const canonical = SITE + (path || "/");
    if (title) document.title = title;
    if (description) {
      setMeta("name", "description", description);
      setMeta("property", "og:description", description);
    }
    if (title) {
      setMeta("property", "og:title", title);
    }
    setMeta("property", "og:type", "website");
    setMeta("property", "og:url", canonical);
    setCanonical(canonical);
  }, [title, description, path]);
  return null;
};
